import { css } from 'styled-components';

const boxShadowLarge = css`
  box-shadow: 0px 2px 4px rgba(92, 101, 117, 0.3), 0px 0px 1px rgba(92, 101, 117, 0.47);
`;

const baseMapElementStyle = css`
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  font-size: 0.88rem;
`;

const baseOverlay = css`
  ${baseMapElementStyle};
  height: 2.50rem;
  padding: 0.62rem 1.00rem;

  span {
    padding-left: 0.41rem;
  }
`;

export { boxShadowLarge, baseMapElementStyle, baseOverlay };
